export enum SupportedLanguagesCodes {
  'Dutch' = 'nl',
  'English' = 'en'
}
